import { render, staticRenderFns } from "./CitationListDataDiscrepancies.vue?vue&type=template&id=95752f9a"
import script from "./CitationListDataDiscrepancies.vue?vue&type=script&lang=js"
export * from "./CitationListDataDiscrepancies.vue?vue&type=script&lang=js"
import style0 from "./CitationListDataDiscrepancies.vue?vue&type=style&index=0&id=95752f9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports